/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-operations-repeat': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M16.25 3.75H3.644L5.88 1.506 5 .625l-3.75 3.75L5 8.125l.881-.881L3.644 5H16.25v4.375h1.25V5c0-.69-.56-1.25-1.25-1.25zm-2.131 9.006L16.356 15H3.75v-4.375H2.5V15c0 .69.56 1.25 1.25 1.25h12.606l-2.237 2.244.881.881 3.75-3.75-3.75-3.75-.881.881z"/>'
  }
})
